import SettingBase from '../settings/util/SettingBase'

class VaultController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'vault'
    this.$state = $state

  }

  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-vault']) {
      this.hasACL[this.acl['setting-vault'][key]] = true;
    }
  }
}
export default VaultController;


// WEBPACK FOOTER //
// ./client/app/components/vault/vault.controller.js